// Fichier calendrier RFC 5545 : échappement, pliage à 75 octets, événement unique.

export function icsEscape(s: string): string {
  return String(s)
    .replace(/\r\n?/g, '\n')
    .replace(/[ --]/g, '')
    .replace(/\\/g, '\\\\')
    .replace(/\n/g, '\\n')
    .replace(/,/g, '\\,')
    .replace(/;/g, '\\;');
}

const ENC = new TextEncoder();
/** Plie une ligne pour ne jamais dépasser 75 octets, sans couper un caractère UTF-8. */
export function foldIcs(line: string): string {
  const lines: string[] = [];
  let chunk = '', bytes = 0;
  for (const ch of line) {
    const n = ENC.encode(ch).length;
    if (bytes + n > 73) { lines.push(chunk); chunk = ' '; bytes = 1; }
    chunk += ch;
    bytes += n;
  }
  lines.push(chunk);
  return lines.join('\r\n');
}

export const icsStamp = (ms: number): string => new Date(ms).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}Z/, 'Z');

export interface IcsEvent {
  uid: string;
  start: number;
  end: number;
  summary: string;
  description?: string;
  url?: string;
  /** Rappel avant le début, en minutes : l'agenda qui ouvre le fichier préviendra de lui-même. */
  alarmMinutes?: number;
  alarmText?: string;
  now: number;
}

export function buildIcs(ev: IcsEvent): string {
  const lines = [
    'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//ACTE.5 WORLD//A5W//FR', 'CALSCALE:GREGORIAN', 'METHOD:PUBLISH',
    'BEGIN:VEVENT',
    'UID:' + icsEscape(ev.uid),
    'DTSTAMP:' + icsStamp(ev.now),
    'DTSTART:' + icsStamp(ev.start),
    'DTEND:' + icsStamp(ev.end),
    'SUMMARY:' + icsEscape(ev.summary),
  ];
  if (ev.description) lines.push('DESCRIPTION:' + icsEscape(ev.description));
  if (ev.url) lines.push('URL:' + icsEscape(ev.url));
  if (ev.alarmMinutes && ev.alarmMinutes > 0) {
    lines.push(
      'BEGIN:VALARM',
      'ACTION:DISPLAY',
      'TRIGGER:-PT' + Math.round(ev.alarmMinutes) + 'M',
      'DESCRIPTION:' + icsEscape(ev.alarmText || ev.summary),
      'END:VALARM',
    );
  }
  lines.push('END:VEVENT', 'END:VCALENDAR');
  return lines.map(foldIcs).join('\r\n') + '\r\n';
}
